import { components } from './components';

// MD3 Type Scale for MUI v5
const themeOptions = {
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif'
    ].join(','),
    fontSize: 14,

    // MD3 Display
    h1: { fontSize: '2.25rem', fontWeight: 400, lineHeight: 1.22, letterSpacing: '-0.02em' },  // Headline Large
    h2: { fontSize: '1.75rem', fontWeight: 400, lineHeight: 1.28, letterSpacing: '-0.01em' },  // Headline Medium
    h3: { fontSize: '1.5rem',  fontWeight: 400, lineHeight: 1.33, letterSpacing: 0 },          // Headline Small
    h4: { fontSize: '1.375rem',fontWeight: 500, lineHeight: 1.27, letterSpacing: 0 },          // Title Large
    h5: { fontSize: '1rem',    fontWeight: 500, lineHeight: 1.5,  letterSpacing: '0.006em' },  // Title Medium
    h6: { fontSize: '0.875rem',fontWeight: 500, lineHeight: 1.43, letterSpacing: '0.007em' },  // Title Small

    // MD3 Body
    body1: { fontSize: '1rem',    fontWeight: 400, lineHeight: 1.5,  letterSpacing: '0.009em' },  // Body Large
    body2: { fontSize: '0.875rem',fontWeight: 400, lineHeight: 1.43, letterSpacing: '0.018em' },  // Body Medium

    // MD3 Label
    button:   { fontSize: '0.875rem', fontWeight: 500, letterSpacing: '0.006em', textTransform: 'none' },
    caption:  { fontSize: '0.75rem',  fontWeight: 500, letterSpacing: '0.025em' },  // Label Medium
    overline: { fontSize: '0.6875rem',fontWeight: 500, letterSpacing: '0.04em', textTransform: 'uppercase' }  // Label Small
  },

  shape: {
    borderRadius: 8   // MD3 default corner radius token
  },

  components: { ...components }
};

export default themeOptions;
